import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { CompanyJobs } from '@/features/company-jobs'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(50),
  filter: z.string().optional().catch(''),
  jobId: z.string().optional(),
  company: z.array(z.string()).optional().catch([]),
  location: z.array(z.string()).optional().catch([]),
  type: z.array(z.string()).optional().catch([]),
  recency: z.array(z.string()).optional().catch([]),
  sortBy: z.string().optional().catch(undefined),
  sortDir: z.enum(['asc', 'desc']).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/company-jobs/tracxn/')({
  validateSearch: searchSchema,
  component: TracxnJobsRoute,
})

function TracxnJobsRoute() {
  return <CompanyJobs source='tracxn' />
}
